import { useEffect, useState, useCallback, useRef } from "react";
import { api } from "@/lib/api";

export function useNetworkStats(pollMs = 3000) {
    const [stats, setStats] = useState(null);
    useEffect(() => {
        let alive = true;
        const load = async () => {
            try {
                const { data } = await api.get("/network/stats");
                if (alive) setStats(data);
            } catch { /* ignore */ }
        };
        load();
        const t = setInterval(load, pollMs);
        return () => { alive = false; clearInterval(t); };
    }, [pollMs]);
    return stats;
}

export function useBlocks(limit = 15, pollMs = 3000) {
    const [blocks, setBlocks] = useState([]);
    const prevHeights = useRef(new Set());
    const [flashHeights, setFlashHeights] = useState(new Set());

    const load = useCallback(async () => {
        try {
            const { data } = await api.get(`/blocks?limit=${limit}`);
            const nowHeights = new Set(data.map((b) => b.height));
            const newOnes = new Set([...nowHeights].filter((h) => !prevHeights.current.has(h)));
            if (prevHeights.current.size > 0 && newOnes.size > 0) {
                setFlashHeights(newOnes);
                setTimeout(() => setFlashHeights(new Set()), 1600);
            }
            prevHeights.current = nowHeights;
            setBlocks(data);
        } catch { /* ignore */ }
    }, [limit]);

    useEffect(() => {
        load();
        const t = setInterval(load, pollMs);
        return () => clearInterval(t);
    }, [load, pollMs]);

    return { blocks, flashHeights };
}

export function useTxs(limit = 25, pollMs = 3000) {
    const [txs, setTxs] = useState([]);
    useEffect(() => {
        let alive = true;
        const load = async () => {
            try {
                const { data } = await api.get(`/transactions?limit=${limit}`);
                if (alive) setTxs(data);
            } catch { /* ignore */ }
        };
        load();
        const t = setInterval(load, pollMs);
        return () => { alive = false; clearInterval(t); };
    }, [limit, pollMs]);
    return txs;
}

export function useValidators(pollMs = 6000) {
    const [validators, setValidators] = useState([]);
    useEffect(() => {
        let alive = true;
        const load = async () => {
            try {
                const { data } = await api.get(`/validators`);
                if (alive) setValidators(data);
            } catch { /* ignore */ }
        };
        load();
        const t = setInterval(load, pollMs);
        return () => { alive = false; clearInterval(t); };
    }, [pollMs]);
    return validators;
}
